// src/components/WinnerOverlay.js
import React, { useState, useEffect } from 'react';
import './WinnerOverlay.css';

function WinnerOverlay({ onClose }) {
  // State to hold the source of the randomly selected winner GIF/image
  const [gifSrc, setGifSrc] = useState('');

  useEffect(() => {
    const imageNames = [
      'bms.gif',
      'boobs.gif',
      'gay-cowboy.gif',
      'gay-dicks-running.gif',
      'goonies-chunk.gif',
      'homealone-eyes.gif',
      'interacial-spanking.gif',
      'jackass.gif',
      'lesbian.gif',
      'movie-blowjob.gif',
      'scary-movie.gif',
      'shuffle-dance.gif',
      'spanking.gif',
      'step-brothers.gif',
      'middle-finger.gif',
      'whip-cream.gif',
    ];

    // Function to select a random winner image from the local list
    const selectRandomWinnerImage = () => {
      if (imageNames.length > 0) {
        // Select a random image from the predefined list
        const randomIndex = Math.floor(Math.random() * imageNames.length);
        const selectedImage = imageNames[randomIndex];
        // Construct the public path for the image.
        // Files in the 'public' directory are served at the root path.
        setGifSrc(`/winner/${selectedImage}`);
      } else {
        // Fallback if no image names are provided in the array
        console.warn("No winner image names provided in the 'imageNames' array. Using a placeholder.");
        setGifSrc("https://placehold.co/600x400/000000/FFFFFF?text=BINGO+Winner");
      }
    };

    selectRandomWinnerImage();
  }, []); // Empty dependency array means this runs once on mount
            // imageNames is now defined inside the effect, so it's not a changing dependency.

  return (
    // Overlay container, clicking anywhere on the background closes it
    <div className="winner-overlay" onClick={onClose}>
      {/* Confetti animation container */}
      <div className="confetti-container"></div>

      {/* Content area, prevents closing if clicking directly on the image/text */}
      <div className="winner-content" onClick={(e) => e.stopPropagation()}>
        {/* Image container with the darkening effect */}
        <div className="winner-image-container">
          {/* Display the randomly selected GIF/image */}
          {gifSrc && <img src={gifSrc} alt="BINGO Winner!" />}

          {/* Large "BINGO" text overlay */}
          <div className="bingo-overlay-text">BINGO</div>

          {/* Explicit close button */}
          <button className="close-overlay-button" onClick={onClose}>×</button>
        </div>
      </div>
    </div>
  );
}

export default WinnerOverlay;
